import { LightDomStyles, OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './outline-breadcrumbs.css.lit';
import { OutlineInlineLink } from '../outline-inline-link/outline-inline-link';

/**
 * The Outline  Breadcrumbs component
 * @element outline-breadcrumbs
 */

@customElement('outline-breadcrumbs')
export class OutlineBreadcrumbs extends OutlineElement {
  static styles = [componentStyles];
  lightDomStyles = new LightDomStyles(
    this,
    [OutlineInlineLink.styles, componentStyles],
    this.tagName.toLowerCase()
  );

  /**
   * Property to define the value of the separator.
   */
  @property({ type: String, attribute: 'string-separator' })
  stringSeparator = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 32"><path class="" d="M17.112 13.902l-12.321-13.043c-1.082-1.146-2.865-1.146-3.948 0s-1.082 3.033 0 4.179l10.315 10.953-10.347 10.953c-1.082 1.146-1.082 3.033 0 4.179 0.541 0.573 1.273 0.876 1.974 0.876 0.732 0 1.433-0.303 1.974-0.876l12.321-13.043c1.114-1.146 1.114-3.033 0.032-4.179z" fill=""/></svg>`;

  firstUpdated(): void {
    const breadcrumbItems: NodeListOf<HTMLLIElement> =
      this.querySelectorAll('li');

    breadcrumbItems.forEach((item, i) => {
      const separator: HTMLSpanElement = document.createElement('span');
      separator.classList.add('separator');
      separator.innerHTML = this.stringSeparator;

      i === breadcrumbItems.length - 1
        ? item.prepend(separator)
        : item.append(separator);
    });
  }

  render(): TemplateResult {
    return html`
      <nav class="breadcrumbs" aria-label="Breadcrumb">
        <slot></slot>
      </nav>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'outline-breadcrumbs': OutlineBreadcrumbs;
  }
}
